import { Component, Inject } from '@angular/core';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { NotificationComponent } from '../notification/notification.component';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';

@Component({
  selector: 'app-send-quotation',
  templateUrl: './send-quotation.component.html',
  styleUrls: ['./send-quotation.component.scss']
})
export class SendQuotationComponent {
  submitted: boolean = false;
  sendQuotationForm = this.fb.group({
    emailList: [[], [Validators.required, this.emailListValidator]],
  });

  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  emailList: any = [];


  constructor(
    public dialogRef: MatDialogRef<SendQuotationComponent>,
    private restService: RestService,
    public loader: LoaderService,
    public fb: FormBuilder,
    public translate: TranslateService,
    private dialog: MatDialog,
    private errorHandler: ErrorHandlerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  add(event: any): void {
    const input = event.input;
    const value = event.value.trim();

    if ((value || '') && this.isValidEmail(value)) {
      this.emailList.push(value);
      this.updateEmailListControl();
    } else if (value) {
      let _dialogRef = this.dialog.open(NotificationComponent, {
        disableClose: true,
        panelClass: 'dialog-class',
        data: {
          block: 'notificationOk',
          message: this.translate.instant('Please enter valid email.')
        }
      });
      _dialogRef.afterClosed().subscribe(result => {
      });
    }

    if (input) {
      input.value = '';
    }
  }

  isValidEmail(email: string): boolean {
    const emailRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegEx.test(email);
  }

  remove(email: string): void {
    const index = this.emailList.indexOf(email);

    if (index >= 0) {
      this.emailList.splice(index, 1);
      this.updateEmailListControl();
    }
  }

  edit(email: any, event: any) {
    const value = event.value.trim();

    if (!value) {
      this.remove(email);
      return;
    }

    if (!this.isValidEmail(value)) {
      // Optionally, you can show an error message here
      return;
    }

    const index = this.emailList.indexOf(email);
    if (index >= 0) {
      this.emailList[index] = value; // Update the email with the new value
    }

    this.updateEmailListControl();
  }


  close() {
    this.dialogRef.close(true);
  }

  emailListValidator(control: FormControl): { [key: string]: boolean } | null {
    const emails = control.value || [];
    const emailRegEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const hasInvalidEmail = emails.some((email: string) => !emailRegEx.test(email));

    return hasInvalidEmail ? { 'invalidEmails': true } : null;
  }

  updateEmailListControl(): void {
    this.sendQuotationForm.controls['emailList'].setValue(this.emailList);
    this.sendQuotationForm.controls['emailList'].updateValueAndValidity();
  }

  submit() {
    this.submitted = true;
    if (this.sendQuotationForm.invalid) {
      return;
    }
    let params = {
      QuotationID: this.data.quotationId,
      Email: this.emailList
    }
    this.loader.show();
    this.restService.postData(params, 'api/Download/SendEmail').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.close();
              let _dialogRef = this.dialog.open(NotificationComponent, {
                disableClose: true,
                width: '75vw',
                panelClass: 'dialog-class',
                data: {
                  block: 'sendQuotation',
                  emailList: this.emailList,
                  emailString: this.emailList.join(', '),
                  referenceNumber: data.rObj.ReferenceNumber
                }
              });
              _dialogRef.afterClosed().subscribe(result => {
                // this.close();
              });
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }
}

